export const defaultFlags = {
  education: false,
  'workspace-members-filter': false,
  'report-subscriptions-to-sentry': false,
  'cwv-custom-grid': false,
  'restricted-uploads': false,
  'components-description': false,
  profiles: false,
  'community-canvas': false,
  'publish-community': false,
  'dark-mode-toggle': false,
  'byok-access': false,
  'frontend-consolidate': false,
  'workspace-integrations': false,
  'slack-mention-notifications': false,
  'command-bar': false,
  // these flags are used when user is not even signed in
  // it is expected that these flags will be changed
  // using DevTools
  'publication-hearts': false,
  'partner-and-resellers-support': false,
  'multiple-selection': false,
  'show-pending-memberships': false,
} as const
